
import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    brand: {
      primary: '#000000',
      secondary: '#99a1a6',
      accent: '#7B04B6',
      dark: '#1d1d1d',
      'dark-page': '#121212',
      positive: '#21BA45',
      negative: '#af0000',
      info: '#31CCEC',
      warning: '#F2C037'
    },
  },
  plugins: {
  }
}